import * as yup from 'yup';
import { MAX_VALID, MIN_VALID, mobilePhoneSchema, REQUIRE_VALID } from '../../data';

export interface ICreateAndEditMemberForm {
  avatar: any;
  firstName: string;
  lastName: string;
  birthday: string;
  mobilePhone: string;
  gender: string;
}

export const CREATE_AND_EDIT_MEMBER_DEFAULT_VALUES = {
  avatar: '',
  firstName: '',
  lastName: '',
  birthday: '',
  mobilePhone: '',
  gender: '',
};

export const CREATE_AND_EDIT_MEMBER_VALIDATION = yup.object({
  avatar: yup
    .mixed()
    .test({
      message: 'validation.error.file.too.big',
      test: (value: any) => {
        return typeof value === 'string' || !value ? true : value?.size < 6_000_000;
      },
    })
    .nullable(),
  firstName: yup.string().required(REQUIRE_VALID).min(2, MIN_VALID(2)).max(100, MAX_VALID(100)),
  lastName: yup.string().required(REQUIRE_VALID).min(2, MIN_VALID(2)).max(100, MAX_VALID(100)),
  birthday: yup.date().required(REQUIRE_VALID),
  mobilePhone: mobilePhoneSchema,
});
